/**
 * ****************************************************************************
 * @description     :   Export all middleware function of saga
 * @created at      :   18/09/2022
 * @created by      :   QuyPN
 * @package         :   ctrl-pnl-fe
 * @copyright       :   Copyright (c) BK HIGH TECH
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * imprt libraries
 */
import { all } from 'redux-saga/effects';

/**
 * impoprt saga of other components
 */
import AppSagas from './app/saga';
import ProfileSagas from './profile/saga';
import UsersSagas from './user/accounts/saga';
import OauthSagas from './oauth/saga';
import ApiKeysSagas from './integration/apiKeys/saga';
import ScreensSagas from './integration/screens/saga';
import FunctionsSagas from './integration/functions/saga';
import MenuItemsSagas from './integration/menuItems/saga';
import ApiSagas from './integration/apis/saga';
import ApiGroupSagas from './integration/apiGroups/saga';
import ScreenGroupSagas from './integration/screenGroups/saga';
import RolesSagas from './system/roles/saga';
import StudentsSagas from './user/students/saga';
import DistrictsSagas from './master/districts/saga';
import CommunesSagas from './master/communes/saga';
import TeachersSaga from './user/teachers/saga';
import WebhookSagas from './integration/webhooks/saga';
import SemesterSagas from './master/semesters/saga';
import ActivityClassSagas from './master/activityClasses/saga';
import FacultySagas from './master/faculties/saga';
import SubjectSagas from './subject/subjects/saga';
import SubjectClassSagas from './subject/subjectClasses/saga';
import SettingsSagas from './system/settings/saga';
import LogsSagas from './system/logs/saga';

/**
 * Fork all function in saga midleware
 * -----------------------------------------
 * @author : QuyPN - 18/09/2022 - create
 * @access : public
 */
export default function* rootSaga() {
  yield all([
    AppSagas(),
    ProfileSagas(),
    UsersSagas(),
    OauthSagas(),
    ApiKeysSagas(),
    ScreensSagas(),
    FunctionsSagas(),
    MenuItemsSagas(),
    ApiSagas(),
    ApiGroupSagas(),
    ScreenGroupSagas(),
    RolesSagas(),
    StudentsSagas(),
    TeachersSaga(),
    DistrictsSagas(),
    CommunesSagas(),
    WebhookSagas(),
    SemesterSagas(),
    ActivityClassSagas(),
    FacultySagas(),
    SubjectSagas(),
    SubjectClassSagas(),
    SettingsSagas(),
    LogsSagas(),
  ]);
}
